module.exports = __webpack_public_path__ + "static/media/country_mv.2fd9ebe3.webp";